import React, { useContext } from "react";
import { configContext } from "../config-provider";
import { debounce } from "../../utils";
import { Search } from "../input";

interface FilterProps {
  compNo?: string;
  iccNo?: string;
  month?: string;
  invType?: string;
  onDebounce?: (value: PhotoFilterState) => void;
}

export interface PhotoFilterState {
  compNo: string;
  iccNo: string;
  month: string;
  invType: string;
}

export const PhotoFilter: React.FC<FilterProps> = (props) => {
  const {
    compNo = "",
    iccNo = "",
    month = "",
    invType = "",
    onDebounce,
  } = props;

  const { dataStartMonth } = useContext(configContext);

  const [state, setState] = React.useState<PhotoFilterState>({
    compNo,
    iccNo,
    month,
    invType,
  });

  React.useEffect(() => {
    debounceOnChange(state);
    // eslint-disable-next-line
  }, [state]);

  const handleOnMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      month: event.target.value,
    });
  };

  const handleOnMonthClear = () => {
    setState({
      ...state,
      month: "",
    });
  };

  const handleOnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    setState({
      ...state,
      [key]: event.target.value,
    });
  };

  // eslint-disable-next-line
  const debounceOnChange = React.useCallback(
    debounce((value: PhotoFilterState) => {
      if (onDebounce) onDebounce(value);
    }, 500),
    []
  );

  return (
    <>
      <div className="filter">
        <div>
          <input
            type="month"
            min={dataStartMonth}
            value={state.month}
            onChange={handleOnMonthChange}
            className="input arcgis-search"
            style={{ padding: "0px 8px" }}
          />
          <small style={{ display: "block", color: "var(--blue-300)" }}>
            {state.month ? (
              <button
                type="button"
                onClick={handleOnMonthClear}
                style={{
                  padding: 0,
                  border: "none",
                  background: "none",
                  font: "inherit",
                  color: "var(--blue-100)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Clear month
              </button>
            ) : (
              "All months"
            )}
          </small>
        </div>
        <Search
          value={state.compNo}
          className="arcgis-search"
          placeholder="Comp No."
          onChange={(evt) => handleOnChange(evt, "compNo")}
        />
        <Search
          value={state.iccNo}
          className="arcgis-search"
          placeholder="ICC No."
          onChange={(evt) => handleOnChange(evt, "iccNo")}
        />
        <Search
          value={state.invType}
          className="arcgis-search"
          placeholder="Inv Type"
          onChange={(evt) => handleOnChange(evt, "invType")}
        />
      </div>
    </>
  );
};
